import React from "react";

function GeneralResults({ results, searchTerm }) {
  return (
    <div>
      {results && results.other && results.other.length !== 0 && (
        <div className="resultsGroup">
          <div className="sectionTitle">Related Results </div>
          <div className="sectionList">
            <ul>
              {results.other.map((link) => (
                <li>
                  {link.url.includes(`http`) ? (
                    <>
                      »{" "}
                      <a href={`${link.url}`} target="_blank">
                        {link.title}
                      </a>
                    </>
                  ) : (
                    <>
                      » <a href={`//www.dreamchimney.com/${link.url}`}>{link.title}</a>
                    </>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default GeneralResults;
